import { motion } from 'framer-motion';

import { Spinner } from './Spinner';

export function FullPageLoader({ label }: { label?: string }): JSX.Element {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-zinc-950/80 backdrop-blur-xl"
    >
      <Spinner size="lg" />
      {label !== undefined && (
        <span className="mt-4 text-sm font-medium text-zinc-300 tracking-wide animate-pulse">
          {label}
        </span>
      )}
    </motion.div>
  );
}
